import InnerPageHero from "../common/InnerPageHero";
import BannerImage from "../../assets/images/about-banner.png"
import "./about.css"
import Growth from "../home/hooks/Growth";
import Growthhead from "../home/hooks/Growthhed";
import Brand from "../home/hooks/Brand";
import ContactForm from "../home/hooks/Contactform";
import Meta from "../Meta";
// import Testimonial from "../common/Testimonial";
export default function About() {
    return(
        <>
        <Meta title={"About us"} />
        <InnerPageHero title={"Activating Growth-One Insight At a Time!"} bgImage={BannerImage} />
        <section className="about-intro text-center">
        <Growthhead />
        </section>
        <Growth />
        <Brand />
        {/* <Testimonial /> */}
        <ContactForm />
        </>
        
    )
}